import {
    SET_AGENT,SET_AGENT_LIST,SET_ACTIVE_AGENTS

} from "./UserActions";

const initialState = {
    agent: {},
    totalAgentList: [],
    totalAgentMap: {},
    activeAgents: []
};

const UserReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_AGENT:
            return {
                ...state,
                agent: action.agent
            };
        case SET_ACTIVE_AGENTS:
            return {
                ...state,
                activeAgents: action.activeAgents
            };
        case SET_AGENT_LIST:
            let objectMap = {};
            if (action.agentList && action.agentList.length > 0) {
                action.agentList.forEach(agent => {
                    objectMap[agent._id] = agent;
                })
            }
            return {
                ...state,
                totalAgentList: action.agentList,
                totalAgentMap: objectMap
            };

        default:
            return state;
    }
};

/* Selectors */
export const getActiveAgentId = (state) => state.user.agent._id;
export const getActiveAgent = (state) => state.user.agent;
export const getTotalAgentMap = (state) => state.user.totalAgentMap;
export const getTotalActiveAgents = (state) => state.user.activeAgents;

export default UserReducer;
